<ng-container *ngIf="!isLoading">
  <div class="date">
    <div class="day">{{ event.date | date: 'dd' }}</div>
    <div class="month">{{ event.date | date: 'MMM' }}</div>
  </div>

  <div class="event-info">
    <h4 class="event-title">
      <a href="{{event.link}}" target="_blank">{{ event.title }}</a>
    </h4>
    <p class="event-description">{{ event.description }}</p>
    <div class="event-time">
      <mat-icon [svgIcon]="'schedule'" class="square-icon time-icon"></mat-icon>
      <span>{{atTimeText}} {{ event.startTime }} {{upToText}} {{ event.endTime }}</span>
    </div>

    <app-event-share-button [btnText]="addToDiaryBtnText" (addToCalendarClick)="addToCalendarClick($event)" />

    <div *ngIf="event.unitName" class="event-unit-name">
      {{ event.unitName }}
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isLoading">
  <app-skeleton [width]="'4.5rem'" [height]="'4.5rem'"/>

  <div class="event-info">
    <app-skeleton [type]="'text'" [symbolsCount]="30" class="event-title"></app-skeleton>
    <app-skeleton [type]="'text'" [symbolsCount]="50" class="event-description"></app-skeleton>

    <div class="event-time">
      <mat-icon [svgIcon]="'schedule'" class="square-icon time-icon"></mat-icon>
      <app-skeleton [type]="'text'" [symbolsCount]="15"></app-skeleton>
    </div>

    <app-skeleton [height]="44"/>
  </div>
</ng-container>